const ACCOUNT_SELECTOR_CONSTANTS = {
    ALL_ACCOUNTS: 'all',
};

export default ACCOUNT_SELECTOR_CONSTANTS;
